import { Info } from "lucide-react";
import React from "react";
import { FieldContext, IFieldContext } from "../../../constants";
import Flex from "../../Flex";
import Tooltip from "../../Tooltip";
import * as S from "./styled";
import { IFieldProps } from "./types";

type TWrapperProps = React.HTMLAttributes<HTMLDivElement>;

type TProps = TWrapperProps & IFieldProps;

const Field: React.FC<TProps> = ({ label, name, children, helperText, error, labelTrailing, tooltip, ...props }) => {
    const inputIdRef = React.useRef<string>();

    if (!inputIdRef.current) {
        inputIdRef.current = name ? `${name}-${Math.random()}` : Math.random().toString();
    }

    const inputId = inputIdRef.current;

    const context = React.useMemo<IFieldContext>(() => ({ id: inputId }), [inputId]);

    return (
        <FieldContext.Provider value={context}>
            <S.Field {...props}>
                {label && (
                    <S.Label htmlFor={inputId}>
                        {label}
                        {labelTrailing}
                        {tooltip && (
                            <Tooltip
                                delayDuration={250}
                                tooltip={<S.TooltipTextWrapper>{tooltip}</S.TooltipTextWrapper>}
                            >
                                <Flex pl={6}>
                                    <Info size={16} />
                                </Flex>
                            </Tooltip>
                        )}
                    </S.Label>
                )}
                {children}
                {((helperText && typeof helperText !== "boolean") || (error && typeof error !== "boolean")) && (
                    <S.HelperText $error={!!error}>{error || helperText}</S.HelperText>
                )}
            </S.Field>
        </FieldContext.Provider>
    );
};

export default Field;
